import { lazy } from 'react'
import { Navigate, useRoutes } from 'react-router-dom'
import Loadable from '../components/Loadable'
import CompactLayout from '../layouts/compact/CompactLayout'
import ContentLayout from '../layouts/ContentLayout'
import MenuLayout from '../layouts/MenuLayout'

const NotFound = Loadable(lazy(() => import('../pages/errors/Error404Page')))
const Forbidden = Loadable(lazy(() => import('../pages/errors/ForbiddenPage')))

const LandingPage = Loadable(lazy(() => import('../pages/autofactura/LandingPage')))
const TerminosPage = Loadable(lazy(() => import('../pages/autofactura/TerminosPage')))
const MenuPage = Loadable(lazy(() => import('../pages/menu/MenuPage')))
const PlatilloDetallePage = Loadable(lazy(() => import('../pages/menu/PlatilloDetallePage')))
const CarritoPage = Loadable(lazy(() => import('../pages/menu/CarritoPage')))
const CheckoutPage = Loadable(lazy(() => import('../pages/menu/CheckoutPage')))
const ConfirmacionPage = Loadable(lazy(() => import('../pages/menu/ConfirmacionPage')))

export default function ThemeRoutes() {
    return useRoutes([
        {
          element: <CompactLayout />,
          children: [
            { path: 'facturar/:idg?/:ids?/:token?', element: <LandingPage /> },
            { path: '404', element: <NotFound /> },
            { path: '401', element: <Forbidden /> },
          ],
        },
        {
          element: <MenuLayout />,
          children: [
            { path: 'menu/:slug', element: <MenuPage /> },
            { path: 'menu/:slug/platillo/:platilloId', element: <PlatilloDetallePage /> },
            { path: 'menu/:slug/carrito', element: <CarritoPage /> },
            { path: 'menu/:slug/checkout', element: <CheckoutPage /> },
            { path: 'menu/:slug/confirmacion', element: <ConfirmacionPage /> },
          ],
        },
        {
          element: <ContentLayout />,
          children : [
            { path: 'aviso_privacidad', element: <TerminosPage /> },
          ]
        },
        { path: '/', element: <Navigate to="/facturar" replace /> },
        { path: '*', element: <Navigate to="/404" replace /> },
    ])
}
